import { AxiosStatic } from 'axios';
import { TFApiResponse } from '../common/types/fapi.types';
import FApiRoutes from '../api/FApiRoutes';
import ApiHelper from '../helpers/ApiHelper';
import {
  IApiBlogEntry,
  IApiBox,
  IApiQuickLink,
  IApiRequestObject, IApiSlide, IApiSocialMedia,
} from '../common/interfaces/api.interface';
import config from '../../config';

export default class FApiService {
  private axios: AxiosStatic;

  constructor(axios: AxiosStatic) {
    this.axios = axios;
    this.axios.defaults.withCredentials = true;
  }

  private async fetch<T>(apiRoute: FApiRoutes, object: IApiRequestObject = {}): Promise<TFApiResponse<T>> {
    let data;
    try {
      const requestConfig = ApiHelper.getRequestConfig(apiRoute, object);
      requestConfig.baseURL = config.fapi.baseurl;
      ({ data } = await this.axios.request(requestConfig));
    } catch (err) {
      ApiHelper.handleKnownApiError(err, apiRoute);
    }
    return data;
  }

  public async getBlogEntries(): Promise<IApiBlogEntry[]> {
    const response = await this.fetch<IApiBlogEntry[]>(FApiRoutes.getBlogEntries);
    return response.data;
  }

  public async getBoxes(): Promise<IApiBox[]> {
    const response = await this.fetch<IApiBox[]>(FApiRoutes.getBoxes);
    return response.data;
  }

  public async getQuickLinks(): Promise<IApiQuickLink[]> {
    const response = await this.fetch<IApiQuickLink[]>(FApiRoutes.getQuickLinks);
    return response.data;
  }

  public async getSlides(): Promise<IApiSlide[]> {
    const response = await this.fetch<IApiSlide[]>(FApiRoutes.getSlides);
    return response.data;
  }

  public async getSocialMedias(): Promise<IApiSocialMedia[]> {
    const response = await this.fetch<IApiSocialMedia[]>(FApiRoutes.getSocialMedias);
    return response.data;
  }
}
